import { render, staticRenderFns } from "./purchaseIncomingInspection-add-or-update.vue?vue&type=template&id=2058a5dc&scoped=true"
import script from "./purchaseIncomingInspection-add-or-update.vue?vue&type=script&lang=js"
export * from "./purchaseIncomingInspection-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./purchaseIncomingInspection-add-or-update.vue?vue&type=style&index=0&id=2058a5dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2058a5dc",
  null
  
)

export default component.exports